import React, { useEffect, useRef } from "react";
import "./Header.css";
import { useSelector } from "react-redux";
import UserMenu from "../../vendor/common/Header";
import {
  getUserRoles,
  getUserTypeName,
  isAdminUser,
} from "../navigation/adminNavigation";

export const AdminHeader = () => {
  const authState = useSelector((state) => state.auth);
  const userRoles = getUserRoles(authState);
  const userType = getUserTypeName(authState);
  const hostRef = useRef(null);

  useEffect(() => {
    if (!isAdminUser(authState)) {
      return undefined;
    }

    const host = hostRef.current;
    const sidebarHost = host?.closest(
      ".user-page__sidebar, .myspace__sidebar, [class*='col-']"
    );

    if (!sidebarHost) {
      return undefined;
    }

    sidebarHost.classList.add("admin-shell__legacy-sidebar-column");
    const contentHost = sidebarHost.nextElementSibling;
    contentHost?.classList.add("admin-shell__legacy-content-column");

    return () => {
      sidebarHost.classList.remove("admin-shell__legacy-sidebar-column");
      contentHost?.classList.remove("admin-shell__legacy-content-column");
    };
  }, [authState]);

  if (userType === "PARTNER") {
    return (
      <div className="admin-header">
        <UserMenu userType={userType} userRoles={userRoles} />
      </div>
    );
  }

  if (isAdminUser(authState)) {
    return (
      <div
        className="admin-header admin-header--adapter"
        ref={hostRef}
        aria-hidden="true"
      />
    );
  }

  return null;
};

export default AdminHeader;
